export default __webpack_public_path__ + "locales/tr/About.json?hash=8dd7e2bd1ae2f4aa9ac83e26031d411d";